import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

const Styles = styled.div`
   .ei-modal {
      z-index: 10000;
      background-color: rgba(0, 0, 0, 0.6);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      transition: opacity 0.25s ease;
      display: none;
   }
   .ei-modal.ei-modal-displayed {
      display: block;
      align-items: center;
      justify-content: center;
   }
   .ei-modal.ei-modal-visible {
      opacity: 1;
   }

   .ei-modal-content {
      position: fixed;
      top: calc(10px + var(--safe-area-inset-top));
      right: calc(10px + var(--safe-area-inset-right));
      transform: scale(0.8);
      transform-origin: calc(100% - 4px) 4px;
      transition: transform 0.25s ease;
      background: var(--background-color);
      border-radius: 30px;
      max-width: min(300px, calc(var(--safe-width) - 20px));
      padding: 0 30px;
      max-height: calc(var(--visible-and-safe-height) - 20px);
      overflow: hidden;
      box-shadow: 0 0 2em -1em rgba(0, 0, 0, 0.6);
   }

   .ei-modal-visible .ei-modal-content {
      transform: scale(1);
   }
`;

const Navigation = ({ display, children, onOverlayClick }) => {
   const [displayed, setDisplayed] = useState(false);
   const [visible, setVisible] = useState(false);

   useEffect(() => {
      if (display) {
         setDisplayed(true);
      }
      if (!display) {
         setVisible(false);
      }
   }, [display]);

   useEffect(() => {
      if (displayed) {
         setTimeout(() => setVisible(true), 50);
      }
   }, [displayed]);

   return (
      <Styles>
         <div
            onClick={(e) => {
               if (e.target === e.currentTarget && onOverlayClick) {
                  onOverlayClick();
               }
            }}
            onTransitionEnd={(e) => {
               if (!display && e.target === e.currentTarget) {
                  setDisplayed(false);
               }
            }}
            className={classNames({
               'ei-modal': true,
               'ei-modal-displayed': displayed,
               'ei-modal-visible': visible,
            })}
         >
            <div className="ei-modal-content">{children}</div>
         </div>
      </Styles>
   );
};

export { Navigation };
